import { CloseOutlined } from '@ant-design/icons';
import { Layout } from 'antd';
import styled from 'styled-components';

import { Button } from '@atom/button/button';
import { ColorEnum } from '@enum/style/color.enum';

interface LayoutSiderProps {
  isMobile: boolean;
  isMobileMenuOpen: boolean;
}

export const LayoutSider = styled(Layout.Sider).attrs({
  trigger: null,
})<LayoutSiderProps>`
  &.ant-layout-sider {
    background-color: ${(props) => props.theme.Sidebar.backgroundColor};
  }

  ${({ isMobile, isMobileMenuOpen }) => isMobile && `display: ${isMobileMenuOpen ? 'block' : 'none'};`}
  ${({ isMobile }) => isMobile && `overflow-y: auto; height: 100dvh; min-width: 380px !important; z-index: 2;`}
`;

export const LogoWrapper = styled.div`
  padding: 48px 0 46px 0;
`;

interface WrapperProps {
  pr: number;
  pd?: number;
}

export const Wrapper = styled.div<WrapperProps>`
  padding: 0 26px ${(props) => props.pd ?? 0}px ${(props) => props.pr}px;
`;

export const LogoButton = styled(Button)`
  padding: 0;
`;

export const Close = styled(CloseOutlined)`
  height: 32px;
  width: 32px;

  & svg {
    width: inherit;
    height: inherit;
    fill: ${ColorEnum.Black50};
  }

  &:hover,
  &:active,
  &:focus {
    & svg {
      fill: ${ColorEnum.Black10};
    }
  }
`;

export const WrapperClose = styled.div`
  position: absolute;
  top: 32px;
  right: 16px;
`;
